var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49609 10.0029L5.49609 10.5429L5.99609 7.50287L11.7261 1.79287C11.8191 1.69914 11.9297 1.62475 12.0515 1.57398C12.1734 1.52321 12.3041 1.49707 12.4361 1.49707C12.5681 1.49707 12.6988 1.52321 12.8207 1.57398C12.9425 1.62475 13.0531 1.69914 13.1461 1.79287L14.2061 2.85287C14.2998 2.94583 14.3742 3.05643 14.425 3.17829C14.4758 3.30015 14.5019 3.43086 14.5019 3.56287C14.5019 3.69488 14.4758 3.82559 14.425 3.94745C14.3742 4.0693 14.2998 4.17991 14.2061 4.27287L8.49609 10.0029Z",
    stroke: "#0C002C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 10.5029V13.5029C12.9961 13.7681 12.8907 14.0225 12.7032 14.21C12.5157 14.3976 12.2613 14.5029 11.9961 14.5029H2.49609C2.23088 14.5029 1.97652 14.3976 1.78899 14.21C1.60145 14.0225 1.49609 13.7681 1.49609 13.5029V4.00293C1.49609 3.73771 1.60145 3.48336 1.78899 3.29582C1.97652 3.10829 2.23088 3.00293 2.49609 3.00293H5.49609",
    stroke: "#0C002C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPen);
export default __webpack_public_path__ + "static/media/ico_pen.753ee7a9075d99fff65dedfed21f0ca6.svg";
export { ForwardRef as ReactComponent };